import { render, staticRenderFns } from "./ChatMessageChart.vue?vue&type=template&id=2589f6b7&scoped=true"
import script from "./ChatMessageChart.vue?vue&type=script&lang=js"
export * from "./ChatMessageChart.vue?vue&type=script&lang=js"
import style0 from "./ChatMessageChart.vue?vue&type=style&index=0&id=2589f6b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2589f6b7",
  null
  
)

export default component.exports